module.exports = __webpack_public_path__ + "img/hy5.1e91c720.jpg";